export default "__VITE_ASSET__Cvl0UfII__"